// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"151":"516708ce","585":"883ab282"}[chunkId] + ".chunk.js";
};